import { makeAutoObservable, runInAction } from 'mobx'
import { notification } from 'antd'
import { openApi } from '../../../helpers/request'
import i from '../../../translations/i'

// Цвета тем мобильных приложений текущего проекта (ksthemes): правят администратор проекта и суперпользователь

export type ThemeName = 'light' | 'dark'
export const THEME_NAMES: ThemeName[] = ['light', 'dark']

// Порядок полей на экране = порядок в ksthemes (App\Models\Themes::COLORS)
export const THEME_COLORS = [
    'colorbtncarthex', 'colorpricehex', 'coloroldpricehex', 'colornavbarbghex', 'colornavbartexthex',
    'colorfavhex', 'colorfavactivehex', 'colortexthex', 'colortapbarbghex', 'colortapbaraccentdefaulthex',
    'colortapbaraccentselectedhex', 'colorbundlehex', 'colorfonhex', 'colorcontainerhex', 'colorinputhex',
    'color_rel_products_hex', 'color_bonus_hex',
]

// Цвета новой темы — как на сервере
const defaultTheme = (): Record<string, string> =>
    Object.fromEntries(THEME_COLORS.map(key => [key, key === 'color_bonus_hex' ? '65C4A3' : '000000']))

class themesController {
    themes: Record<ThemeName, Record<string, string>> = { light: defaultTheme(), dark: defaultTheme() }
    exists: Record<ThemeName, boolean> = { light: true, dark: true }
    loaded = false

    constructor() {
        makeAutoObservable(this)
    }

    get() {
        openApi('get', '/setting/themes')
            .then(result => runInAction(() => {
                THEME_NAMES.forEach(name => {
                    const theme = result.data?.[name]
                    this.exists[name] = !!theme
                    this.themes[name] = theme ? { ...defaultTheme(), ...theme } : defaultTheme()
                })
                this.loaded = true
            }))
            .catch(err => console.log(err))
    }

    setColor(name: ThemeName, key: string, hex: string) {
        this.themes[name][key] = hex.toUpperCase()
    }

    save(name: ThemeName) {
        const data = new FormData()
        THEME_COLORS.forEach(key => data.append(key, this.themes[name][key]))

        openApi('post', `/setting/themes/${name}`, data)
            .then(result => runInAction(() => {
                this.themes[name] = { ...defaultTheme(), ...result.data }
                this.exists[name] = true
                notification.success({ message: i.t('settings:appThemes.saved') })
            }))
            .catch(err => notification.error({ message: err?.response?.data?.data?.message ?? i.t('def:errors.error') }))
    }
}

export default new themesController()
